import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";

import InputField from "../../admin/childComponents/inputComponents/InputField";
import TextArea from "../../admin/childComponents/inputComponents/TextArea";
import CAPTCHATurnStile from "../../admin/childComponents/appComponents/CAPTCHATurnStile";
import Loading from "../../admin/childComponents/appComponents/Loading";

import "../../../assets/css/ContactSection.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const INITIAL_FORM = {
  input: {
    names: "",
    email: "",
    mobile: "",
    subject: "",
  },
  textArea: {
    textMessage: "",
  },
};

function ContactSection() {
  const [loading, setLoading] = useState(false);
  const [reCaptcha, setReCaptcha] = useState(false);
  const [formData, setFormData] = useState(INITIAL_FORM);

  const updateFormData = (type, key, value) => {
    setFormData((previous) => ({
      ...previous,
      [type]: {
        ...previous[type],
        [key]: value,
      },
    }));
  };

  const resetForm = () => {
    setFormData({
      input: { ...INITIAL_FORM.input },
      textArea: { ...INITIAL_FORM.textArea },
    });
    setReCaptcha(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading || !reCaptcha) return;

    setLoading(true);

    const formPayload = new FormData();
    formPayload.append("names", formData.input.names.trim());
    formPayload.append("email", formData.input.email.trim());
    formPayload.append("mobile", formData.input.mobile.trim());
    formPayload.append("subject", formData.input.subject.trim());
    formPayload.append("textMessage", formData.textArea.textMessage.trim());
    formPayload.append("typeRequest", "FOI");

    try {
      await axios.get("/sanctum/csrf-cookie");
      const response = await axios.post(`${BASE_URL}fbdata`, formPayload);

      if (response?.data?.status === 200) {
        swal(
          "Message Sent",
          response.data.message ||
            "Thank you for contacting the Ministry. Your message has been received.",
          "success",
        );
        resetForm();
      } else {
        swal(
          "Unable to Send",
          response?.data?.message ||
            "Something went wrong. Please review your details and try again.",
          "error",
        );
      }
    } catch (error) {
      console.error("Contact form submission failed:", error);
      swal(
        "Submission Failed",
        "We could not send your message. Please try again later.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="cs-section section">
      <div className="container">
        <header className="cs-heading" data-aos="fade-up">
          <span className="cs-eyebrow">WE ARE HERE TO HELP</span>
          <h2>Contact the Ministry</h2>
          {/* <p>
            Have a question, enquiry or feedback? Send us a message and
            our team will direct it to the appropriate office.
          </p> */}
          <span className="cs-heading-accent" />
        </header>

        <div className="cs-layout" data-aos="fade-up" data-aos-delay="100">
          <aside className="cs-contact-panel">
            <div className="cs-panel-heading">
              <span className="cs-panel-icon">
                <i className="bi bi-headset" aria-hidden="true" />
              </span>
              <div>
                <span className="cs-panel-eyebrow">GET IN TOUCH</span>
                <h3>Contact Information</h3>
              </div>
            </div>

            <div className="cs-contact-item">
              <span className="cs-contact-icon">
                <i className="fa fa-map-marker-alt" aria-hidden="true" />
              </span>
              <div>
                <h4>Our Address</h4>
                <p>Federal Ministry of Housing and Urban Development</p>
                <p>Headquarters, Mabushi, Abuja</p>
              </div>
            </div>

            <div className="cs-contact-item">
              <span className="cs-contact-icon">
                <i className="fa-solid fa-phone" aria-hidden="true" />
              </span>
              <div>
                <h4>Call Us</h4>
                <p>
                  <a href="tel:+2348061743313">+234 806 174 3313</a>
                </p>
                <p>Monday to Friday, 8:00 am – 4:00 pm</p>
              </div>
            </div>

            <div className="cs-contact-item">
              <span className="cs-contact-icon">
                <i className="fa-solid fa-envelope" aria-hidden="true" />
              </span>
              <div>
                <h4>Email Us</h4>
                <p>
                  <a href="mailto:info@fmhud.gov.ng">info@fmhud.gov.ng</a>
                </p>
                <p>
                  <a href="mailto:hmregistry@fmhud.gov.ng">Minister Registry</a>
                </p>
                <p>
                  <a href="mailto:hmsregistry@fmhud.gov.ng">Minister of State</a>
                </p>
                <p>
                  <a href="mailto:psregistry@fmhud.gov.ng">Permanent Secretary</a>
                </p>
              </div>
            </div>

            <div className="cs-map-wrap">
              <div className="cs-map-heading">
                <i className="bi bi-geo-alt" aria-hidden="true" />
                <span>Find our office</span>
              </div>
              <iframe
                title="Federal Ministry of Housing and Urban Development location"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3939.8214274164316!2d7.453387!3d9.080027!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0b0051bb9dff%3A0xb06406a0d062ec36!2sFederal%20Ministry%20of%20Housing%20and%20Urban%20Development!5e0!3m2!1sen!2sng!4v1777032230675!5m2!1sen!2sng"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </aside>

          <div className="cs-form-panel">
            <div className="cs-form-heading">
              <span className="cs-form-eyebrow">SEND AN ENQUIRY</span>
              <h3>We would love to hear from you</h3>
              {/* <p>
                Complete the form below. Fields marked as required must be
                filled in.
              </p> */}
            </div>

            <form onSubmit={handleSubmit} className="cs-form">
              <div className="cs-form-grid">
                <div className="cs-field cs-field-full">
                  <InputField
                    label="Your Full Name"
                    name="names"
                    size="14"
                    required="required"
                    value={formData.input.names}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>

                <div className="cs-field">
                  <InputField
                    label="Email Address"
                    name="email"
                    size="14"
                    required="required"
                    value={formData.input.email}
                    type="email"
                    onChange={updateFormData}
                  />
                </div>

                <div className="cs-field">
                  <InputField
                    label="Phone Number"
                    name="mobile"
                    size="14"
                    required="required"
                    value={formData.input.mobile}
                    type="tel"
                    onChange={updateFormData}
                  />
                </div>

                <div className="cs-field cs-field-full">
                  <InputField
                    label="Subject"
                    name="subject"
                    size="14"
                    required="required"
                    value={formData.input.subject}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>

                <div className="cs-field cs-field-full">
                  <TextArea
                    label="Your Message"
                    name="textMessage"
                    size="14"
                    rows={7}
                    required="required"
                    value={formData.textArea.textMessage}
                    onChange={updateFormData}
                  />
                </div>

                <div className="cs-field cs-field-full cs-captcha">
                  <CAPTCHATurnStile
                    reCaptcha={reCaptcha}
                    setReCaptcha={setReCaptcha}
                  />
                </div>

                <div className="cs-field cs-field-full cs-submit-row">
                  <p className="cs-privacy-note">
                    <i className="bi bi-shield-check" aria-hidden="true" />
                    Your information will be used to respond to your enquiry.
                  </p>
                  <button
                    type="submit"
                    className="cs-submit-button"
                    disabled={!reCaptcha || loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="cs-button-spinner"
                          aria-hidden="true"
                        />
                        Sending message...
                      </>
                    ) : (
                      <>
                        Send Message
                        <i className="bi bi-arrow-right" aria-hidden="true" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default React.memo(ContactSection);
